"use client";

import DemoButton from "../Demo/DemoButton";
import StartTrialBtn from "../StartTrialBtn";
const Banner = () => {
  return (
    <>
      <div className="banner_bg">
        <div className="container banner_container">
          <div className="banner_container_left">
            <h1 className="banner_heading">
              Create smarter solutions delivering actionable insights leveraging
              video data.
            </h1>
            <p className="banner_text">
              Analyze video content in real time by extracting meta data &
              rendering actionable intelligence.
            </p>
            <div className="banner_btn_container">
              <div>
                <DemoButton />
              </div>
              <StartTrialBtn />
            </div>
          </div>

          <div className="banner_container_right">
            <video
              autoPlay
              loop
              muted
              playsInline
              className="banner_video"
              width={644}
              height={420}
            >
              <source src="/video/Visionfacts.mp4" type="video/mp4" />
              Your browser does not support the video tag.
            </video>
          </div>
        </div>
      </div>
    </>
  );
};

export default Banner;
